import axios from 'axios';
import axiosRetry from 'axios-retry';

import { ServerVersion, attemptReload } from './utils/version';

const APIBaseURLS = {
  development: process.env.API_BASE_URL,
  staging: process.env.API_BASE_URL || 'https://blade-api-staging.redmeru.com/api/',
  experimental: 'https://api.experimental.redmeru.com/api/',
  corpstaging: 'https://api.staging.corporate.redmeru.com/api/',
  aus: 'https://api.staging.aus.redmeru.com/api/',
  // TODO: Production backend
  production: process.env.API_BASE_URL || 'https://api.production.redmeru.com/api/'
};

const DashboardUrls = {
  development: 'http://localhost:8081',
  experimental: 'https://dashboards.experimental.redmeru.com',
  corpstaging: 'https://dashboards.staging.corporate.redmeru.com',
  almas: 'https://dashboards.almas.bladeplatform.us',
  deloitte: 'https://dashboards.deloitte.bladeplatform.us'
};

const debugOverrideApiUrl = undefined;

let selectedEnvironment = (process.env.OVERRIDE_ENV || process.env.NODE_ENV);
if (selectedEnvironment === 'undefined') {
  selectedEnvironment = 'development';
}

// Workaround for local development environments
let workingBaseUrl = debugOverrideApiUrl
|| APIBaseURLS[process.env.OVERRIDE_ENV || process.env.NODE_ENV]
|| process.env.API_BASE_URL;

const isLocalhost = window.location.hostname === 'localhost';

// If the browser isn't accessing this from localhost, use the domain it's actually being accessed from.
if (workingBaseUrl.includes('localhost') && !isLocalhost) {
  workingBaseUrl = workingBaseUrl.replace('localhost', window.location.hostname);
}

export const APIBaseURL =
  workingBaseUrl
;


// Inconsistent because this is new.  The above should be change at some point.
export const DashboardURL = DashboardUrls[selectedEnvironment]
  || process.env.DASHBOARD_DEFAULT_URL;

console.log({ DashboardURL, selectedEnvironment });

export const axiosAPIInstance = axios.create({
  baseURL: APIBaseURL
});

const isNetworkError = error =>
  error && // just to make sure
  !error.response && // if there is a response, it reached the server and not a network error
  error.code !== 'ECONNABORTED'; // check that it isn't a timeout

const retryCondition = error =>
  isNetworkError(error) || // my custom check
  axiosRetry.isIdempotentRequestError(error); // retry lib check

axiosRetry(axiosAPIInstance, { retries: 3, retryDelay: axiosRetry.exponentialDelay, retryCondition });

let hasTokenExpired = false;
export const connectAPIInstanceToStore = (store) => {
  axiosAPIInstance.interceptors.request.use(
    (config) => {
      if (config.ignoreAdditionalHeaders) return config;
      config.headers['x-version'] = ServerVersion;

      const { authToken } = store.getters;
      // eslint-disable-next-line no-param-reassign
      if (authToken) config.headers['x-auth'] = authToken;
      return config;
    },
    err => Promise.reject(err)
  );

  axiosAPIInstance.interceptors.response.use(
    (response) => {
      const authToken = response.headers['x-auth'];
      if (authToken) store.dispatch('storeAuthToken', { authToken });
      return response;
    },
    (err) => {
      // err.response is undefined if no server response
      const { data, status } = err.response || {};
      if (status === 401 && data === 'Token Expired') {
        if (!hasTokenExpired) {
          // eslint-disable-next-line no-alert
          alert('Your session has expired.  Please log in again.');
          // refresh the page
          store.dispatch('logout');
          window.location.reload();

          // prevent spamming if we sent multiple requests
          hasTokenExpired = true;
        }
      }
      if (status === 400 && data === 'ServerVersionMismatch') {
        // eslint-disable-next-line no-alert
        attemptReload('Your client version is out of date');
        return;
      }
      return Promise.reject(err);
    }
  );
};



// WEBPACK FOOTER //
// ./src/axios-config.js